export const TIPO_BOLETO = {
  FECHAMENTO: 1,
  AVULSO: 2,
  ADESAO: 3,
  PRIMEIRA_PARCELA: 4,
  REATIVACAO: 5,
  CANCELAMENTO: 6,
  PARTICIPACAO: 7,
};
